export const CASELOAD_TABS = ['clients', 'contacts'] as const;
export type CaseloadTab = (typeof CASELOAD_TABS)[number];

export function resolveCaseloadActiveTab(tabParam: string | null): CaseloadTab {
  if (tabParam && (CASELOAD_TABS as readonly string[]).includes(tabParam)) {
    return tabParam as CaseloadTab;
  }
  return 'clients';
}
